<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label [nzSpan]="10"  [nzRequired]="wrapper.element.required" [nzNoColon]="true"></nz-form-label>
		<nz-form-control [nzSpan]="10"  [nzAutoTips]="wrapper.autoTips">
			<label nz-checkbox [formControlName]="toControlKey(wrapper.element)" [nzDisabled]="readonly">{{ wrapper.element.name }}</label>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<label nz-checkbox [formControlName]="toControlKey(wrapper.element)" [nzDisabled]="readonly">{{ wrapper.element.name }}</label>
		</nz-form-control>
	</nz-form-item>
</div>
